// src/components/tutor/diagnostics/TutorDiagnosticReportPage.js
//
// The Tutor portal's standalone report route reuses the shared, portal-agnostic
// StandaloneDiagnosticReport page so Admin and Tutor open reports identically
// (focused single-report tab, no portal chrome).
//
// Tutors are an active-reports-only audience: archived diagnostic reports are an
// admin-only feature. We force the "active" variant here so an archived viewer
// can never be reached from the Tutor portal, even via a hand-typed URL.

import React from "react";
import StandaloneDiagnosticReport from "../../admin/diagnostics/StandaloneDiagnosticReport";

export default function TutorDiagnosticReportPage() {
  return <StandaloneDiagnosticReport forceVariant="active" />;
}
